import userService from "../services/user.service";

const users = {
  namespaced: true,
  state: {},
  actions: {
    getAll() {
      return userService.getAll();
    },
    getOne(_, userId) {
      return userService.getOne(userId);
    },
    getSet(_, userIds) {
      return userService.getSet(userIds);
    },
    getAccisureReps() {
      return userService.getAccisureReps();
    },
    resetPassword(_, userId) {
      return userService.resetPassword(userId);
    },
    updateUser(_, user) {
      return userService.update(user);
    },
    addUser(_, user) {
      return userService.add(user);
    },
    deleteUser(_, user) {
      return userService.delete(user);
    },
  },
  getters: {},
  mutations: {},
};

export default users;
